import { InfluencerSelectedAccountInfo } from '../../types';
import { InfluencerProfileEstimatedAudience } from '../../InfluencerProfiles';

export interface InfluencerAnalyticsTwitterProfileAudienceProps {
  socialAccount: InfluencerSelectedAccountInfo;
}

export const InfluencerAnalyticsTwitterProfileAudience = ({
  socialAccount
}: InfluencerAnalyticsTwitterProfileAudienceProps) => (
  <InfluencerProfileEstimatedAudience socialAccount={socialAccount} />
);
